import React from 'react';
import { ReactComponent as Clipboard } from 'assets/icons/ui-elements/small/clipboard-sm.svg';
import { ReactComponent as User } from 'assets/icons/ui-elements/small/user-sm.svg';
import { ReactComponent as House } from 'assets/icons/ui-elements/small/house-sm.svg';
import { ReactComponent as DownIcon } from 'assets/icons/ui-elements/small/caret-down-sm.svg';
import { FiltersContainer, TypeFilterContainer, TypeButton, OpenModalButton } from '../styled';
import { EventType } from '../../../hooks/useCalendarFilters';

interface CalendarFiltersProps {
  type: EventType;
  onTypeChange: (type: EventType) => void;
  onOpenExecutoresModal: () => void;
  onOpenAmbientesModal: () => void;
  onOpenPlanosModal: () => void;
  planosSelectionLabel: string;
}

export const CalendarFilters: React.FC<CalendarFiltersProps> = ({
  type,
  onTypeChange,
  onOpenExecutoresModal,
  onOpenAmbientesModal,
  onOpenPlanosModal,
  planosSelectionLabel,
}) => {
  return (
    <FiltersContainer>
      <TypeFilterContainer>
        <TypeButton isActive={type === 'pendentes'} onClick={() => onTypeChange('pendentes')} isRight={false}>
          Pendentes
        </TypeButton>
        <TypeButton isActive={type === 'baixadas'} onClick={() => onTypeChange('baixadas')} isRight={true}>
          Baixadas
        </TypeButton>
      </TypeFilterContainer>
      <OpenModalButton onClick={onOpenPlanosModal} width={'100%'} size="small">
        <div>
          <Clipboard /> Planos{planosSelectionLabel}
        </div>
        <DownIcon />
      </OpenModalButton>
      <OpenModalButton onClick={onOpenExecutoresModal} width={'100%'} size="small">
        <div>
          <User /> Executores e Setores
        </div>
        <DownIcon />
      </OpenModalButton>
      <OpenModalButton onClick={onOpenAmbientesModal} width={'100%'} size="small">
        <div>
          <House /> Ambientes e Equipamentos
        </div>
        <DownIcon />
      </OpenModalButton>
    </FiltersContainer>
  );
};
